module.exports = __webpack_public_path__ + "img/navigation_browser_1.c220a41c.png";